import { render, staticRenderFns } from "./workDataDetial.vue?vue&type=template&id=e38c05b0&scoped=true"
import script from "./workDataDetial.vue?vue&type=script&lang=js"
export * from "./workDataDetial.vue?vue&type=script&lang=js"
import style0 from "./workDataDetial.vue?vue&type=style&index=0&id=e38c05b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38c05b0",
  null
  
)

export default component.exports